"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectModels = void 0;
var ProjectModels;
(function (ProjectModels) {
    class ProjectReportModel {
        constructor(id, name) {
            this.id = id;
            this.name = name;
        }
    }
    ProjectModels.ProjectReportModel = ProjectReportModel;
    class ProjectInformationModel {
        constructor(id, name, environment) {
            this.id = id;
            this.name = name;
            this.environment = environment;
        }
    }
    ProjectModels.ProjectInformationModel = ProjectInformationModel;
    class ProjectVariantContentItemModel {
        constructor(id, name, codename) {
            this.id = id;
            this.name = name;
            this.codename = codename;
        }
    }
    ProjectModels.ProjectVariantContentItemModel = ProjectVariantContentItemModel;
    class ProjectVariantLanguageModel {
        constructor(id, name, codename) {
            this.id = id;
            this.name = name;
            this.codename = codename;
        }
    }
    ProjectModels.ProjectVariantLanguageModel = ProjectVariantLanguageModel;
    class ProjectVariantElementModel {
        constructor(id, name, codename) {
            this.id = id;
            this.name = name;
            this.codename = codename;
        }
    }
    ProjectModels.ProjectVariantElementModel = ProjectVariantElementModel;
    class ProjectTypeIssueModel {
        constructor(type, issues) {
            this.type = type;
            this.issues = issues;
        }
    }
    ProjectModels.ProjectTypeIssueModel = ProjectTypeIssueModel;
    class ProjectTypeModel {
        constructor(id, name, codename) {
            this.id = id;
            this.name = name;
            this.codename = codename;
        }
    }
    ProjectModels.ProjectTypeModel = ProjectTypeModel;
    class ProjectIssueModel {
        constructor(element, messages) {
            this.element = element;
            this.messages = messages;
        }
    }
    ProjectModels.ProjectIssueModel = ProjectIssueModel;
    class ProjectVariantIssueModel {
        constructor(item, language, issues) {
            this.item = item;
            this.language = language;
            this.issues = issues;
        }
    }
    ProjectModels.ProjectVariantIssueModel = ProjectVariantIssueModel;
})(ProjectModels = exports.ProjectModels || (exports.ProjectModels = {}));
//# sourceMappingURL=project.models.js.map